import React from "react";

export const AwardContext = React.createContext({
    doSearch: null,
    isEdit: null,
    parent: null,
});